import { BaseApiModel } from './BaseApiModel';

export class CftvFiles extends BaseApiModel {
  public urlCurrent: string;
  public urlDecrypted: string;
  public type: string;
}
